import { Tab, Typography } from '@mui/material';
import React from 'react';
import WithSkeleton from 'ui-component/extended/WithSkeleton';

const SkeletonTab = () => (
  <Tab
    iconPosition="start"
    label={
      <WithSkeleton isLoading>
        <Typography>
          Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum
        </Typography>
      </WithSkeleton>
    }
  />
);

export default SkeletonTab;
